<template>
    <div class="images-grid"></div>
</template>

<script>
    import Muuri from 'muuri'
    import * as $ from 'jquery'
    import { getPageIndex } from "../services/page.services";

    export default {
        name: 'images-grid',
        props: ['items', 'front', 'back'],
        data() {
            return {
                grid: null,
                old: []
            }
        },
        mounted() {
            this.createGrid()

            this.createEvents()

            if (this.items) {
                this.items.forEach(it => this.add(it))
                this.old = this.items.slice()
            }
        },
        methods: {
            createGrid() {
                this.grid = new Muuri('.images-grid', {
                    dragEnabled: true
                })
            },
            createEvents() {
                $(document).off()

                $(document).on('click', '.close-icon', (e) => {
                    const value = e.target.getAttribute('data-value')
                    this.$emit('remove', value)
                })

                $(document).on('dblclick', '.images-grid-item-content', (e) => {
                    const value = e.currentTarget.getAttribute('data-value')
                    this.$emit('item-click', value)
                })

                this.grid.on('layoutEnd', items => {
                    const images = items.map(it => it.getElement())
                        .map(ele => ele.children[0])
                        .map(ele => ele.getAttribute('data-value'))
                    this.$emit('sort', images)
                    this.updateIndices()
                })
            },
            add(item) {
                const generatedItem = this.generateItem(item)
                this.grid.add(generatedItem)
            },
            remove(item) {
                const items = this.grid.getItems()
                    .filter(it => {
                        const val = it.getElement().children[0].getAttribute('data-value')
                        return val === item.checksum
                    })
                this.grid.remove(items, {removeElements: true})
            },
            generateItem(data) {
                let item = document.createElement('div')
                item.innerHTML = `<div class="images-grid-item">
                                    <div class="images-grid-item-content" data-value="${data.checksum}">
                                        <span class="v-badge v-badge--left v-badge--overlap">
                                            <span>
                                                <div class="image-wrap">
                                                    <img
                                                        class="upload-image"
                                                        src="${data.url}"/>
                                                    <i
                                                        aria-hidden="true"
                                                        class="v-icon material-icons theme--light close-icon"
                                                        data-value="${data.checksum}"
                                                    >close</i>
                                                </div>
                                            </span>
                                            <span class="v-badge__badge primary">
                                                <span class="image-index-label">2</span>
                                            </span>
                                        </span>
                                    </div>
                                  </div>`
                return item.firstChild
            },
            updateIndices() {
                this.grid.getItems().forEach((item, i, arr) => {
                    item.getElement().querySelector('.image-index-label').innerHTML =
                        getPageIndex(i, arr, this.front, this.back)
                })
            }
        },
        watch: {
            items: function (val) {
                if (val.length > this.old.length) {
                    // when added
                    const newItems = val.slice(this.old.length)
                    newItems.forEach(item => this.add(item))
                    this.old = this.items.slice()
                } else if (val.length < this.old.length) {
                    // when removed
                    let diff = []
                    this.old.forEach(item => {
                        const index = this.items.findIndex(it =>
                            it.checksum === item.checksum)
                        if (index === -1) diff.push(item)
                    })
                    diff.forEach(it => this.remove(it))
                    this.old = this.items.slice()
                }
            },
            front: function () {
                this.updateIndices()
            },
            back: function () {
                this.updateIndices()
            }
        }
    }
</script>

<style>
    /*muuri popupImages grid*/
    .images-grid {
        position: relative;
    }

    .images-grid-item {
        display: block;
        position: absolute;
        width: 170px;
        height: 220px;
        margin: 5px;
        z-index: 1;
        background: #000;
        color: #fff;
    }

    .images-grid-item.muuri-item-dragging {
        z-index: 3;
    }

    .images-grid-item.muuri-item-releasing {
        z-index: 2;
    }

    .images-grid-item.muuri-item-hidden {
        z-index: 0;
    }

    .images-grid-item-content {
        position: relative;
        width: 100%;
        height: 100%;
    }

    /*muuri popupImages grid*/

    .close-icon {
        color: #3D3E3F;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 20px !important;
        font-weight: bold;
    }

    .image-index-label {
        font-weight: bold;
    }

    .upload-image {
        object-fit: cover;
        width: 170px;
        height: 220px;
    }
</style>
